/**
 * ЕДИНСТВЕННЫЙ файл папки марафонов клуба со своим содержимым на каждом сайте (план §4.4).
 * Остальная папка src/features/clubMarathons/ копируется между site-rus (.life) и site_eng
 * (.com) байт в байт — это сверяет __manifest__.json (manifest.test.ts).
 *
 * Это — .com (torsunov.com, site_eng):
 *  - сервер — site_server (запись с окном start + weeks и audience, api/shapeCom.ts);
 *  - вход — подписанный `site_session_token` (как у пульта марафонов клуба и админки марафонов);
 *  - ворот нет: права решает роль из /manage/me (руководитель, помощник, админ и, как сейчас,
 *    «открыто по баллам» — создавать или предлагать);
 *  - баллы в «За что баллы» — все строки «Как получить баллы» сайта (.com начисляет каждую);
 *  - «Поделиться»: Telegram, ВКонтакте, WhatsApp, «Скопировать»;
 *  - ссылка участникам («Поделиться», QR) — страница клуба с блоками участника марафона
 *    (решение 03.11 (a)): «Лига участников» на .com только для админов, участнику там «404».
 */
import { siteSessionToken } from "@/shared/api/adminHeaders";
import { getRouteCommunityClub } from "@/shared/config/router";
import type { ShareTarget } from "./share";

export const BACKEND: "life" | "com" = "com";

export const authToken = (): string => siteSessionToken();

const OPEN = { enabled: true, loading: false };

/** Открыты ли новые экраны марафонов (на .com ворот нет — права решает роль). */
export const useMarathonsGate = (): { enabled: boolean; loading: boolean } => OPEN;

/** Строка «Как получить баллы» годится для правил марафона (.com начисляет все). */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const pointsRow = (_row: unknown): boolean => true;

export const SHARE_TARGETS: ShareTarget[] = ["telegram", "vk", "whatsapp", "copy"];

/**
 * Путь страницы, где участник видит марафон своего клуба (без origin): страница клуба,
 * ?marathon= открывает на ней блоки участника (pages/ClubPage, ClubMarathonSection).
 */
export const memberPath = (id: string, lang: string, clubId: string | null): string =>
    `${getRouteCommunityClub(lang)}?${clubId ? `club=${encodeURIComponent(clubId)}&` : ""}marathon=${encodeURIComponent(id)}`;
